export default __webpack_public_path__ + "static/media/tut1novoville.eb4ff989.png";